// ============================================================================
// Imports
// ============================================================================
import React, { useState, useRef } from "react";
import theme from "../../../styles/theme";

// Fonction utilitaire déjà définie dans ton projet
import { getUserColor } from "../../../utils/getUserColor";


// ============================================================================
// Composant AssignedUsersMultiSelector
// ============================================================================
const AssignedUsersMultiSelector = ({
  label = "Assignés",
  values = [],          // array de value
  options = [],         // [{ value, label }]
  onChange,

  width = "100%",
  height = 40,
  labelWidth = 120,
  gap = 6,
  marginTop = 0,
  marginBottom = 8,
  padding = "6px 8px",
  style = {},
}) => {

  const containerRef = useRef(null);

  // Ajouter un utilisateur ou le retirer
  const handleToggle = (value) => {
    if (values.includes(value)) {
      onChange(values.filter((v) => v !== value));
    } else {
      onChange([...values, value]);
    }
  };

  // Fonction dédiée pour retirer un utilisateur
  const removeUser = (value) => {
    onChange(values.filter((v) => v !== value));
  };


  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width,
        marginTop,
        marginBottom,
        gap,
        ...style,
      }}
    >
      {/* LABEL */}
      <div
        style={{
          width: labelWidth,
          fontSize: theme.fontSizes.sm,
          color: theme.colors.text.label,
          fontWeight: theme.fontWeights.medium,
          userSelect: "none",
        }}
      >
        {label}
      </div>

      {/* ZONE INNER (tags + select) */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          height,
          padding,
          display: "flex",
          alignItems: "center",
          borderRadius: theme.borders.radius.md,
          border: `1px solid ${theme.colors.borders.default}`,
          background: theme.colors.background.surface,

          overflowX: "auto",
          overflowY: "hidden",
          whiteSpace: "nowrap",

          gap: 6,

          // cache les scrollbar Firefox/Edge/Chrome
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        ref={containerRef}
      >

        {/* TAGS SELECTIONNÉS */}
        {values.map((val) => {
          const user = options.find((o) => o.value === val);
          if (!user) return null;

          // Couleur stable depuis ton thème
          const colorKey = getUserColor(user.label);
          const c = theme.Avatar.colors[colorKey];

          return (
            <div
              key={val}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "3px 8px",
                borderRadius: 6,
                background: c.background,
                color: c.color,
                whiteSpace: "nowrap",
                userSelect: "none",
              }}
            >
              <span style={{ fontSize: 12 }}>{user.label}</span>

              {/* Bouton de suppression */}
              <span
                onClick={() => removeUser(val)}
                style={{
                  fontSize: 10,
                  marginLeft: 4,
                  opacity: 0.8,
                  cursor: "pointer",
                }}
              >
                ✕
              </span>
            </div>
          );
        })}

        {/* SELECTEUR POUR AJOUTER UN UTILISATEUR */}
        <select
          style={{
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: theme.fontSizes.sm,
            cursor: "pointer",
            minWidth: 120,
          }}
          onChange={(e) => {
            if (!e.target.value) return;
            handleToggle(e.target.value);
            e.target.value = ""; // reset après ajout
          }}
        >
          <option value="">+ Ajouter</option>
          {options
            .filter((o) => !values.includes(o.value))
            .map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default AssignedUsersMultiSelector;
